"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tfs_css_variables_1 = __importDefault(require("tfs.css-variables"));
exports.default = {
    profile: {
        display: 'flex',
        gridRow: function (props) { return props.gridRow; },
        gridColumn: function (props) { return props.gridColumn; },
        gridColumnSpan: function (props) { return props.gridColumnSpan; },
        msGridRow: function (props) { return props.gridRow; },
        msGridColumn: function (props) { return props.gridColumn; },
        msGridColumnSpan: function (props) { return props.gridColumnSpan; },
        '& > *': {
            margin: 0,
            fontWeight: 'bold',
        },
        '& > :first-child': {
            padding: [0, '1rem', 0],
        },
        '& > :last-child': {
            borderLeft: "1px solid " + tfs_css_variables_1.default.colorGrayE,
            padding: [0, 0, 0, '1rem'],
        },
    },
};
//# sourceMappingURL=NavigationProfile.styles.js.map